import type { DevTaskPriority, DevTaskStatus } from "../types";

export const defaultDevTaskStatuses: DevTaskStatus[] = [
  { value: "backlog", label: "Backlog" },
  { value: "todo", label: "À faire" },
  { value: "in-progress", label: "En cours" },
  { value: "in-review", label: "En revue" },
  // Sprint 5 T5.1 — état non-terminal bloqué côté client. Placé après
  // in-review (notre travail fini, on attend un retour externe) et
  // avant done/canceled. Pas d'enforce DB (status reste text libre,
  // cf migration placeholder 20260511120100). Volontairement exclu
  // de MyDayTickets.ACTIVE_STATUSES car "en attente client" = pas
  // d'action immédiate pour le dev.
  { value: "en_attente_client", label: "En attente client" },
  { value: "done", label: "Terminé" },
  { value: "canceled", label: "Annulé" },
];

export const defaultDevTaskPriorities: DevTaskPriority[] = [
  {
    value: "none",
    label: "Aucune",
    icon: "SignalZero",
    colorClass: "text-muted-foreground",
  },
  {
    value: "urgent",
    label: "Urgent",
    icon: "AlertTriangle",
    colorClass: "text-red-600",
  },
  {
    value: "high",
    label: "Élevée",
    icon: "SignalHigh",
    colorClass: "text-orange-500",
  },
  {
    value: "medium",
    label: "Moyenne",
    icon: "SignalMedium",
    colorClass: "text-yellow-600",
  },
  {
    value: "low",
    label: "Faible",
    icon: "SignalLow",
    colorClass: "text-blue-500",
  },
];
